import { render, staticRenderFns } from "./roleCheck.vue?vue&type=template&id=0d31cb22&scoped=true&"
import script from "./roleCheck.vue?vue&type=script&lang=js&"
export * from "./roleCheck.vue?vue&type=script&lang=js&"
import style0 from "./roleCheck.vue?vue&type=style&index=0&id=0d31cb22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d31cb22",
  null
  
)

export default component.exports